module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Dollar-abba8516ee3f4d4b5a5a9fdb5aaed1ea.svg";